import ApplicationController from "./application_controller";

export default class extends ApplicationController {

  connect(){
    this.validateEmailInput();
  }
  setValue(e) {
    e.currentTarget.setAttribute("value", e.currentTarget.value);
  }

  clearInputError() {
    this.element.classList.remove("input--has-error");
    const inputSubmitContainer = this.element.parentElement;
    const submitBtn = inputSubmitContainer.querySelector(".input--submit-container--btn");
    submitBtn.removeAttribute("data-label");
    submitBtn.classList.remove("is-submitted");
    submitBtn.querySelector(".input--submit-container--btn--text").textContent = "Submit";
  }

  validateEmailInput() {
    const emailInput = document.querySelector('.input--submit-container--input')
    if (emailInput.checkValidity()) {
      document.querySelector('.input--submit-container--btn').classList.remove('disabled');
      emailInput.style.border = "1px solid #ccc";
    } else {
      document.querySelector('.input--submit-container--btn').classList.add('disabled');
      emailInput.style.border = "1px solid #dc3545";
    }
  }
}